document.addEventListener("DOMContentLoaded", () => {
    console.log('Modal cargado');
  
    const modal = document.getElementById("modalRejectOffer");
    if (!modal) return;
  
    const titleField = modal.querySelector(".ofert-title");
    const clientField = modal.querySelector(".ofert-client");
    const countryField = modal.querySelector(".ofert-country");
    const reasonTextarea = modal.querySelector("#rejectReasonInput");
    const confirmButton = modal.querySelector("#confirmRejectBtn");
    const cancelButton = modal.querySelector(".btn-secondary");
    const charCount = modal.querySelector(".modal-reject-char-count");
  
    let currentUrl = null;
  
    const urlParams = new URLSearchParams(window.location.search);
    const isRejectedView = urlParams.get("state") === "rejected";
  
    // MODO: RECHAZAR OFERTA
   
    document.body.addEventListener("click", (e) => {
      const button = e.target.closest(".btn-reject-offer");
      if (!button) return;
  
      e.preventDefault();
  
      titleField.textContent = button.dataset.title || 'Sin título';
      clientField.textContent = button.dataset.client || 'Cliente desconocido';
      countryField.textContent = button.dataset.country || 'País no definido';
      reasonTextarea.value = "";
      reasonTextarea.removeAttribute("readonly");
      reasonTextarea.classList.remove("bg-light", "border-0");
  
      currentUrl = button.dataset.url;
      modal.querySelector(".modal-title").textContent = "Rechazar oferta";
      confirmButton.style.display = "";
      cancelButton.textContent = "Cancelar";
  
      $('#modalRejectOffer').modal('show');
    });
  
   
    // MODO: VER MOTIVO DE RECHAZO
    if (isRejectedView) {
        document.body.addEventListener("click", (e) => {
          const button = e.target.closest(".btn-view-rejection");
          if (!button) return;
      
          e.preventDefault();
      
          titleField.textContent = button.dataset.title || 'Sin título';
          clientField.textContent = button.dataset.client || 'Cliente desconocido';
          countryField.textContent = button.dataset.country || 'País no definido';
      
          // Ocultar textarea, contador y cambiar título
          reasonTextarea.classList.add("d-none");
          charCount.classList.remove("d-flex");
          charCount.classList.add("d-none");
          const dynamicTitle = modal.querySelector(".modal-reject-dynamic-title");
          if (dynamicTitle) dynamicTitle.textContent = "Motivo del rechazo";

      
          // Mostrar bloque readonly
          const reasonField = modal.querySelector(".view-reason");
          const adminField = modal.querySelector(".view-admin");
          const emailField = modal.querySelector(".view-email");
          const dateField = modal.querySelector(".view-date");
          const readonlyBlock = modal.querySelector(".modal-reject-readonly");
      
          if (readonlyBlock) readonlyBlock.classList.remove("d-none");
          if (reasonField) reasonField.textContent = button.dataset.reason || "Motivo no disponible";
          if (adminField) adminField.textContent = button.dataset.admin || "N/D";
          if (emailField) emailField.textContent = button.dataset.email || "N/D";
          if (dateField) dateField.textContent = button.dataset.date || "N/D";
      
          // Ajustes visuales
          modal.querySelector(".modal-title").textContent = "Información del rechazo";
          confirmButton.style.display = "none";
          cancelButton.textContent = "Cerrar";
      
          $('#modalRejectOffer').modal('show');
        });
      }
      
  

    // CONTADOR DE CARACTERES
    reasonTextarea.addEventListener("input", function () {
      if (this.value.length > 200) {
        this.value = this.value.slice(0, 200);
      }
      if (charCount) {
        charCount.textContent = `${this.value.length} / 200`;
      }
    });
  

    // ENVÍO DEL RECHAZO
    confirmButton.addEventListener("click", function () {
      const reason = reasonTextarea.value.trim();
  
      if (!reason) {
        alert("Debes ingresar un motivo para rechazar la oferta.");
        return;
      }
  
      if (!currentUrl) return;
  
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción rechazará la oferta. ¿Deseas continuar?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, rechazar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            url: currentUrl,
            type: 'PATCH',
            headers: {
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            },
            data: {
              rejection_reason: reason
            },
            success: function () {
              $('#modalRejectOffer').modal('hide');
  
              Swal.fire({
                icon: 'success',
                title: '¡Rechazada!',
                text: 'La oferta fue rechazada correctamente.',
                timer: 1800,
                showConfirmButton: false
              }).then(() => {
                window.location.href = "/admin/ofertas/externas";
              });
            },
            error: function () {
              Swal.fire("Error", "Ocurrió un error al rechazar la oferta.", "error");
            }
          });
        }
      });
    });
  

    // RESTAURAR MODAL AL CERRAR
    $('#modalRejectOffer').on('hidden.bs.modal', function () {
      reasonTextarea.removeAttribute("readonly");
      reasonTextarea.classList.remove("bg-light", "border-0");
      reasonTextarea.value = "";
      confirmButton.style.display = "";
      cancelButton.textContent = "Cancelar";
      modal.querySelector(".modal-title").textContent = "Rechazar oferta";
      if (charCount) {
        charCount.textContent = "0 / 200";
      }

      reasonTextarea.classList.remove("d-none");
    if (charCount) charCount.classList.remove("d-none");
    const readonlyBlock = modal.querySelector(".modal-reject-readonly");
     if (readonlyBlock) readonlyBlock.classList.add("d-none");

    });
  });